// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"b1419bcb","422":"fa7ba7a8"}[chunkId] + ".chunk.css";
};